import { useHttpClient } from '@hakimo-ui/hakimo/util';
import { Selectable } from '@hakimo-ui/shared/ui-base';

export function useTenantsByName() {
  const httpClient = useHttpClient();

  return (name: string) => {
    const url = `/v2/orm/admin/tenants?tenantName=${encodeURIComponent(name)}`;

    return httpClient<Selectable[]>(url, {
      responseModifier: async (response) => {
        const res = await response.json();
        return (res.payload ?? []).map((t: { id: string; name: string }) => ({
          id: t.id,
          name: t.name,
        }));
      },
    });
  };
}

export default useTenantsByName;
